import { choices } from "../config-generics/aeKao";
import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

const taneClothingSizes = [
  "SML",
  "MED",
  "LRG",
  "XLG",
  "2XL",
  "3XL",
  "4XL",
  "5XL",
];
const wahineClothingSizes = ["XSM", "SML", "MED", "LRG", "XLG"];

export const participantConfig: PageConfig[] = [
  {
    name: "participantDetails",
    title: "Participant Details",
    questions: [
      {
        name: "allergies",
        title: `
            Does the participant have any allergies, including dietary
            requirements?
          `,
        type: "radiogroup",
        choices,
        isRequired: true,
      },
      {
        name: "allergyDetails",
        title: `
            Please list all allergies, as well as medications and dosage
            required
          `,
        type: "comment",
        visibleIf: "{allergies} = 'Āe'",
        isRequired: true,
      },
      {
        name: "conditions",
        title: `
            Does the participant have any medical conditions or disabilities
            that could impact their involvement on this wānanga?
          `,
        type: "radiogroup",
        choices,
        isRequired: true,
      },
      {
        name: "conditionDetails",
        title: `
            please list. It is important that we are aware of all needs of our
            tamariki/rangatahi that will attend our wānanga so we can be
            accommodating to all. 
          `,
        type: "comment",
        visibleIf: "{conditions} = 'Āe'",
        isRequired: true,
      },
    ],
  },
  {
    name: "clothingSize",
    title: "Clothing Size",
    questions: [
      {
        name: "sizeImages",
        title: "",
        type: "html",
        html: `
            <table>
              <tr><th>Wāhine Sizing</th><th>Tāne Sizing</th></tr>
              <tr><td>
                <a href="/images/forms/wahineSizing.jpg" target="_blank">
                  <img
                    src="/images/forms/wahineSizing.jpg"
                    style="width: 35vw"
                  />
                </a>
              </td><td>
                <a href="/images/forms/taneSizing.jpg" target="_blank">
                  <img
                    src="/images/forms/taneSizing.jpg"
                    style="width: 35vw"
                  />
                </a>
              </td></tr>
            </table>
          `,
      },
      {
        name: "sizeType",
        title: "T-Shirt Type",
        type: "radiogroup",
        choices: ["Wāhine", "Tāne"],
        isRequired: true,
      },
      {
        name: "sizeWahine",
        title: "Size",
        type: "dropdown",
        visibleIf: '{sizeType} = "Wāhine"',
        choices: wahineClothingSizes,
        isRequired: true,
      },
      {
        name: "sizeTane",
        title: "Size",
        type: "dropdown",
        visibleIf: '{sizeType} = "Tāne"',
        choices: taneClothingSizes,
        isRequired: true,
      },
    ],
  },
];
